import { Users } from "lucide-react";

import { StatusBadge } from "../../components/StatusBadge";
import { clientsApi } from "../../api/directory";
import { DirectoryListPage } from "./DirectoryListPage";
import { CLIENT_STATUSES } from "./statuses";

const COLUMNS = [
  { key: "full_name", header: "Name", render: (row) => <strong>{row.full_name}</strong> },
  {
    key: "status",
    header: "Status",
    render: (row) => <StatusBadge statuses={CLIENT_STATUSES} value={row.status} />,
  },
  { key: "age", header: "Age", className: "numeric" },
  { key: "phone", header: "Phone", render: (row) => row.phone || "—" },
  { key: "city", header: "City", render: (row) => row.city || "—" },
];

export function ClientsPage() {
  return (
    <DirectoryListPage
      title="Clients"
      description="People your agency provides care for."
      resource={clientsApi}
      statuses={CLIENT_STATUSES}
      columns={COLUMNS}
      basePath="/clients"
      addLabel="Add client"
      searchPlaceholder="Search clients"
      emptyMessage="No clients yet. Add your first one to get started."
      emptyIcon={Users}
      emptyTone="rose"
    />
  );
}
